<small class="help-block m-b-none text-danger" class="p-invalid" *ngIf="hasError()">
  <i class="fa fa-remove"></i>{{mensagemErro}}
</small>
